import { PageHeader, Card, CardHeader } from "../components/primitives";

const BLOCKS = [
  {n:"Tone from the top",status:"green",evidence:"Board statement on AML appetite ratified 22 Apr 2026; CEO town-hall 18 May 2026 included AML risk update.",detail:"Risk appetite statement reviewed quarterly; non-negotiable for senior leadership."},
  {n:"Leadership engagement",status:"green",evidence:"Board AML Committee meets monthly; 100% attendance for the last 6 sessions.",detail:"Minutes circulated to all directors within 48h."},
  {n:"Quality monitoring",status:"green",evidence:"Internal audit · 2 cycles per year · KPMG independent validation Q2 2026.",detail:"3 minor findings in last validation; all in remediation."},
  {n:"Sufficient resourcing",status:"amber",evidence:"Compliance headcount at 92% of peer benchmark; tech budget 4.2% of operating expenditure.",detail:"Two senior analyst seats open; expected to close June 2026."},
  {n:"Risk/reward balance",status:"green",evidence:"7 customer relationships de-banked YTD on AML grounds; 3 deals declined.",detail:"Compliance metrics weight ≥15% in performance reviews for relationship managers."},
  {n:"AML as business-as-usual",status:"green",evidence:"AML embedded in onboarding · RM dashboards · operations playbooks.",detail:"AML touchpoint mandatory in 11 of the bank's standard processes."},
  {n:"Training and communication",status:"green",evidence:"94% of compliance staff up-to-date · annual mandatory AML training programme renewed.",detail:"Targeted content for PEP screening, sanctions, structuring detection."},
];

export default function ComplianceCulture() {
  return (
    <div>
      <PageHeader title="Compliance Culture" subtitle="KPMG seven-blocks framework — operationalised" sections={["5.9"]} />
      <div className="p-6 grid grid-cols-2 gap-3">
        {BLOCKS.map((b, i) => (
          <Card key={i}>
            <CardHeader title={`${i+1}. ${b.n}`} right={<span className={`w-1.5 h-1.5 rounded-full ${b.status === 'green' ? 'bg-risk-low' : b.status === 'amber' ? 'bg-risk-medium' : 'bg-risk-high'}`} />} />
            <div className="p-4 text-[12px] space-y-2">
              <div><div className="text-[10px] text-ink-subtle uppercase tracking-wider mb-1">Evidence</div>{b.evidence}</div>
              <div className="text-ink-muted">{b.detail}</div>
              <button className="text-[11px] text-amber-600">View supporting documents →</button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
